import { useEffect, useState } from "react";
import {
    ACTIVE_COMPANY_API_EVENT,
    getActiveCompanyIdApi,
} from "./client";

type ActiveCompanyApiState = {
    value: string | null;
    resolved: boolean;
};

export function useActiveCompanyIdApi(): ActiveCompanyApiState {
    const [state, setState] = useState<ActiveCompanyApiState>(() => {
        return {
            value: getActiveCompanyIdApi(),
            resolved: false,
        };
    });

    useEffect(() => {
        const syncFromStorage = () => {
            setState({
                value: getActiveCompanyIdApi(),
                resolved: true,
            });
        };

        const handleCompanyChange = (event: Event) => {
            const detail = (event as CustomEvent<{ id?: string | null }>).detail;

            setState({
                value: detail?.id ?? getActiveCompanyIdApi(),
                resolved: true,
            });
        };

        window.addEventListener("storage", syncFromStorage);
        window.addEventListener(ACTIVE_COMPANY_API_EVENT, handleCompanyChange as EventListener);
        syncFromStorage();

        return () => {
            window.removeEventListener("storage", syncFromStorage);
            window.removeEventListener(ACTIVE_COMPANY_API_EVENT, handleCompanyChange as EventListener);
        };
    }, []);

    return state;
}
